/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'

// css
import { Button } from '@styles/button.style'
import PopupUtils from '@utils/popup-utils'

export const ServerChecklistBannerStyle = css`
  width: 100%;
  min-height: 77px;
  border-radius: 8px;
  overflow: hidden;
  > img {
    width: 100%;
    object-fit: contain;
  }
`

export const ServerChecklistBanner: React.FC = observer((): React.ReactElement => {
  const { componentStore } = useRootStore()
  const { maintenanceBanner } = componentStore

  const onClickAdvNoticePopup = (): void => {
    if (maintenanceBanner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(maintenanceBanner)
      PopupUtils.showMatchupBannerPopup()
    }
  }

  return (
    <Button
      noRadius
      TP
      css={ServerChecklistBannerStyle}
      onClick={(): void => {onClickAdvNoticePopup()}}
    >
      <img
        src={maintenanceBanner.homeImageUrl}
        alt={maintenanceBanner.desc}
      />
    </Button>
  )
})
